import { Box } from "@mui/material"
import Text from "../Text"
import { theme } from "src/providers/ThemeProvider"

interface ITemTagProps {
  temCount: number
  disabled?: boolean
}

const TemTag = ({ temCount, disabled = false }: ITemTagProps) => {
  const imgName = disabled ? "tem_tag_disabled" : "tem_tag"
  return (
    <Box
      width={80}
      sx={{
        maxWidth: 100,
        backgroundImage: `url('/assets/images/${imgName}.png')`,
        backgroundRepeat: "round",
        backgroundSize: "conver",
        [theme.breakpoints.down(500)]: {
          width: 70,
        },
      }}
    >
      <Text
        padding="6px 0px"
        color="white"
        textAlign="center"
        fontSize={13}
        lineHeight="17.15px"
        sx={{
          [theme.breakpoints.down(500)]: {
            fontSize: "11px !important",
            lineHeight: "16px !important",
          },
        }}
      >
        {temCount} TEM
      </Text>
    </Box>
  )
}

export default TemTag
